export const INITIAL = 'initial';
export const OPEN = 'open';
export const RECONNECTING = 'reconnecting';
export const FAILED_TO_CONNECT = 'failedToConnect';
export const FAILED_TO_RECONNECT = 'failedToReconnect';
